export default __webpack_public_path__ + "static/media/movie-episode-2.353f60ba.jpg";